export class GeocoderResponse {
  status: GeocoderStatus;
  error_message: string;
  results: google.maps.GeocoderResult[] | null;

  constructor(
    status: GeocoderStatus,
    results: google.maps.GeocoderResult[] | null,
  ) {
    this.status = status;
    this.results = results;
  }
}

export enum GeocoderStatus {
  /**
   * There was a problem contacting the Google servers.
   */
  ERROR = 'ERROR',
  /**
   * This <code>GeocoderRequest</code> was invalid.
   */
  INVALID_REQUEST = 'INVALID_REQUEST',
  /**
   * The response contains a valid <code>GeocoderResponse</code>.
   */
  OK = 'OK',
  /**
   * The webpage has gone over the requests limit in too short a period of
   * time.
   */
  OVER_QUERY_LIMIT = 'OVER_QUERY_LIMIT',
  /**
   * The webpage is not allowed to use the geocoder.
   */
  REQUEST_DENIED = 'REQUEST_DENIED',
  /**
   * A geocoding request could not be processed due to a server error. The
   * request may succeed if you try again.
   */
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  /**
   * No result was found for this <code>GeocoderRequest</code>.
   */
  ZERO_RESULTS = 'ZERO_RESULTS',
}
